import { Flex } from '@chakra-ui/react'
import styled from '@emotion/styled'

import theme from 'styles/theme'

export const AuthorsWrapper = styled(Flex)`
  overflow-x: none;
  margin-top: 30px;
  padding-bottom: 12px;
  padding-left: 20px;
  height: 55px;

  @media (min-width: ${theme.token('breakpoints.lg')}) {
    max-width: calc(50% + 10px);
    height: 70px;
    padding-right: calc((100% - 1320px) / 2);
    width: 100%;
    overflow: auto;
    padding-left: 10px;
    margin-right: 20px;
  }
`

export const AuthorButton = styled.button<{ isCurrentlyVisible: boolean }>`
  display: flex;
  align-items: center;
  margin-right: ${({ isCurrentlyVisible }) => (isCurrentlyVisible ? 'auto' : '10px')};
  min-width: ${({ isCurrentlyVisible }) => (isCurrentlyVisible ? '170px' : '40px')};
  cursor: pointer;

  &:focus {
    outline: none;
  }
`

export const AuthorPhoto = styled.img<{ isCurrentlyVisible: boolean }>`
  border-radius: 100%;
  width: 32px;
  height: 32px;
  transform: ${({ isCurrentlyVisible }) => (isCurrentlyVisible ? 'scale(1.3)' : 'scale(1)')};
  opacity: ${({ isCurrentlyVisible }) => (isCurrentlyVisible ? 1 : 0.5)};
  transition: transform 0.3s ease;
`

export const StyledSlider = styled.div`
  overflow-x: hidden;
  position: relative;
  height: 100px;

  @media (min-width: ${theme.token('breakpoints.lg')}) {
    width: 50%;
  }
`

export const Slide = styled.div<{
  isActive: boolean
  isPrevious: boolean
  isNext: boolean
}>`
  position: absolute;
  top: 0;
  width: 100%;
  opacity: ${({ isActive }) => (isActive ? 1 : 0)};
  transform: ${({ isNext, isPrevious }) =>
    isNext ? 'translateX(100%)' : isPrevious ? 'translateX(-100%)' : 'translate(0)'};
  z-index: ${({ isActive, isPrevious, isNext }) => (isActive ? 900 : isNext || isPrevious ? 800 : 100)};
  transition: transform 0.5s, opacity 0.5s, z-index 0.5s;
`

export const ArrowButton = styled.button<{ isDisabled: boolean }>`
  opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)};
  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'all')};
  cursor: pointer;
  color: ${theme.token.var('colors.green.a200')};
`
